import React from 'react';
import './BackBody.scss';

const BackBody = () => (
    <>
        <div className="back-body position-fixed" />
    </>
);

export default BackBody;